<template>
  <div id="stock-manager">
    <v-card :flat="flat" :class="{ transparent: flat }">
      <v-container :pa-0="noPadding" fluid>
        <v-row>
          <!-- Search field -->
          <v-col cols="12" md="4">
            <v-list-subheader class="pl-0 d-block" style="height: auto">
              Search for {{ stock_label }}
            </v-list-subheader>

            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="tempGroup.stock"
                  :items="searchResults"
                  :loading="loading"
                  :hide-no-data="!searchInput || searchInput.length < 1 || loading"
                  no-filter
                  no-data-text="No such stock found"
                  return-object
                  :item-title="formatName"
                  item-value="id"
                  multiple
                  variant="outlined"
                  density="compact"
                  :prepend-inner-icon="mdiMagnify"
                  hide-details
                  class="pt-0"
                  @update:search="onSearchInput"
                  @update:model-value="clearSearch"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- Filter filers -->
            <v-row v-if="mutualFund">
              <v-col>
                <v-select
                  v-model="filterInput"
                  :items="filtersItems"
                  item-title="text"
                  hide-details
                  variant="outlined"
                  density="compact"
                  class="pt-0"
                  style="max-width: 225px"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="8">
                <v-text-field
                  v-model="ticker_list.list_text"
                  label="Tickers to Add"
                  variant="outlined"
                  maxlength="100"
                  density="compact"
                  max="100"
                  hint="Add a list of tickers separated by commas or spaces (max 100 characters)"
                  persistent-hint
                />
              </v-col>
              <v-col cols="auto">
                <v-btn variant="outlined" @click="import_list()"> Add Tickers </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <!-- Selected stocks list -->
          <v-col cols="12" md="8">
            <v-row no-gutters>
              <v-col grow>
                <v-list-subheader class="pl-0 d-block" style="height: auto">
                  Selected {{ stock_label }}
                  <span class="text-grey">({{ stockGroupProxy.length }})</span>
                </v-list-subheader>
              </v-col>
              <v-col class="shrink">
                <v-btn
                  v-if="stockGroupProxy.length"
                  text
                  color="error"
                  class="ma-0"
                  style="height: auto"
                  @click="clearSelection()"
                >
                  Clear
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <span v-if="!stockGroupProxy.length">
                  {{
                    required
                      ? 'You must select at least one stock.'
                      : mutualFund
                        ? 'No mutual fund(s)/ETF(s) selected.'
                        : 'No stocks selected.'
                  }}
                </span>

                <template v-else>
                  <v-chip
                    v-for="stock in stockGroupProxy"
                    :key="stock.id"
                    size="small"
                    label
                    closable
                    color="primary"
                    class="ma-1 text-white"
                    @click:close="removeStockById(stock.id)"
                  >
                    {{ stock.ticker[0] }} {{ stock.name }}
                  </v-chip>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Modules
import api from '@/store/api'
import { mdiMagnify } from '@mdi/js'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: {
    flat: Boolean,
    noPadding: Boolean,
    stockGroup: Object,
    required: Boolean,
    mutualFund: Boolean
  },
  emits: ['update:stockGroup'],

  data: () => ({
    mdiMagnify,
    loading: false,
    stockGroupProxy: [], //{stocks:[]},
    //stocksProxy: [],
    searchInput: null,
    tempGroup: { stock: null },
    searchResults: [],
    ticker_list: { list_text: '' },
    filterInput: 0,
    filtersItems: [
      { text: 'Include Any', value: 0 },
      { text: 'Mutual Funds or ETFs', value: 1 },
      { text: 'ETF Only', value: 2 },
      { text: 'Mutual Fund Only', value: 3 }
    ]
  }),
  computed: {
    stock_label() {
      var label = 'Stocks'
      if (this.mutualFund) {
        label = 'Mutual Fund(s)/ETF(s)'
      }
      return label
    }
  },

  watch: {
    'tempGroup.stock'(val) {
      if (val != null && val.length > 0) {
        //TODO check that stock is not already in group

        this.stockGroupProxy.push(val[0])
        this.emitUpdate()
        this.tempGroup.stock = null
      }
    },
    stockGroup: {
      immediate: true,
      deep: true,
      handler(newVal) {
        // Only sync from parent if the prop actually changed (not from our own emit)
        if (newVal && JSON.stringify(newVal) !== JSON.stringify(this.stockGroupProxy)) {
          this.stockGroupProxy = cloneDeep(newVal)
        }
      }
    }
  },

  mounted() {
    if (this.mutualFund) {
      this.filtersItems.splice(0, 1)
      this.filterInput = 1
    }
  },
  methods: {
    formatName(item) {
      if (!item || !item.ticker) {
        return ''
      }
      return item.ticker[0] + ' ' + item.name
    },
    onSearchInput(val) {
      this.searchInput = val ?? ''
      if (val && val.length > 0) this.querySearch(val)
    },
    import_list() {
      //send to server which will return array of matches, add to group up to limit, clear out list
      if (
        this.loading ||
        this.ticker_list.list_text.trim().length == 0 ||
        this.ticker_list.list_text.trim().length > 100
      ) {
        return
      }
      this.loading = true
      const query = `ticker_lookup?tickers=${this.ticker_list.list_text}`
      api
        .get(query)
        .then(res => {
          var tickers = res.data
          for (var i = 0; i < tickers.length; i++) {
            var s = tickers[i]
            this.stockGroupProxy.push({
              id: s.id,
              name: s.name,
              permalink: s.permalink,
              ticker: [s.symbol]
            })
          }
          this.emitUpdate()
          this.ticker_list.list_text = ''
        })
        .then(() => (this.loading = false))
    },
    querySearch(val) {
      if (!val || val.length == 0) return
      this.loading = true
      const query = `stock_autocomplete?restrictions=${this.filterInput}&keyword=${val}`
      api
        .get(query)
        .then(res => {
          if (res.data && res.data.length > 0) this.searchResults = res.data
          else this.searchResults = []
        })
        .then(() => (this.loading = false))
    },

    removeStockById(id) {
      const index = this.stockGroupProxy.findIndex(stock => stock.id === id)
      this.stockGroupProxy.splice(index, 1)
      this.emitUpdate()
    },

    clearSelection() {
      if (!window.confirm('Are you sure you want to clear your current stock selection?')) {
        return
      }
      this.stockGroupProxy = [] // {stocks:[]}
      this.emitUpdate()
    },
    clearSearch() {
      // This method is called when a selection is made
      this.searchInput = ''
    },
    emitUpdate() {
      this.$emit('update:stockGroup', cloneDeep(this.stockGroupProxy))
    }
  }
}
</script>
